import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { create } from 'kts-scaffold-framework/utils/form';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Form, Row, Col, Input, DatePicker, Button, InputNumber, Select } from 'antd';

const FormItem = Form.Item;
const Option = Select.Option;

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class AuthRecordFilter extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    handleSearch = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            ModulesAction.handleFormChange(values);
        });
    }
    render() {
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 }
        };
        const { form: { getFieldDecorator } } = this.props;
        return (
            <div className="mb-10">
                <Form
                    onSubmit={this.handleSearch}
                >
                    <Row>
                        <Col span={8} >
                            <FormItem
                                label="结算单号"
                                {...formItemLayout}
                            >
                                {getFieldDecorator('fuzzyBizNoticeId')(
                                    <Input placeholder="支持模糊查询" />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={8} >
                            <FormItem {...formItemLayout} label='购方名称'>
                                {getFieldDecorator('fuzzyBuyerName')(
                                    <Input placeholder="支持模糊查询" />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={8} >
                            <FormItem
                                label="创建日期"
                                {...formItemLayout}
                            >
                                <Col span={11}>
                                    <FormItem>
                                        {getFieldDecorator('minCreateTime')(
                                            <DatePicker style={{ width: '100%' }} />
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={2}>
                                    <span style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}>
                                        -
                            </span>
                                </Col>
                                <Col span={11}>
                                    <FormItem>
                                        {getFieldDecorator('maxCreateTime')(
                                            <DatePicker style={{ width: '100%' }} />
                                        )}
                                    </FormItem>
                                </Col>
                            </FormItem>
                        </Col>
                        <Col span={8} >
                            <FormItem
                                label="价税合计"
                                {...formItemLayout}
                            >
                                <Col span={11}>
                                    <FormItem>
                                        {getFieldDecorator('minAmountSum')(
                                            <InputNumber style={{ width: '100%' }} precision={2} />
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={2}>
                                    <span style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}>
                                        -
                            </span>
                                </Col>
                                <Col span={11}>
                                    <FormItem>
                                        {getFieldDecorator('maxAmountSum')(
                                            <InputNumber style={{ width: '100%' }} precision={2} />
                                        )}
                                    </FormItem>
                                </Col>
                            </FormItem>
                        </Col>
                        <Col span={8} >
                            <FormItem {...formItemLayout} label={`状态`}>
                                {getFieldDecorator('noticeBillState')(
                                    <Select allowClear={true} >
                                        <Option value="REFUSED">已拒绝</Option>
                                        <Option value="ACCEPTED">已接受</Option>
                                        <Option value="SENDED">已送达</Option>
                                        <Option value="INVALID">已作废</Option>
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={8} >
                            <FormItem {...formItemLayout} label={`开票状态`}>
                                {getFieldDecorator('makeInvoiceState')(
                                    <Select allowClear={true} >
                                        <Option value="1">已开票</Option>
                                        <Option value="0">未开票</Option>
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={24} >
                            <div className="pull-right">
                                <Button className="mr10" onClick={this.handleReset}>清空</Button>
                                <Button type="primary" htmlType="submit">筛选</Button>
                            </div>
                        </Col>

                    </Row>
                </Form>
            </div>
        );
    }
    private handleReset = () => {
        this.props.form.resetFields();
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/OutputSettlement/UI.List.Filter.tsx